// Rows a register reads better as one line per level: RT06's 47 DAS remote
// unit conduits are 47 located rows, shown as "DAS remote unit conduit x 14"
// on each level (the way the reference register lists them) that opens into
// the units. Only these types fold; every other row stays as it is.
export const GROUPED_TYPES = new Set(["DAS remote unit conduit"]);

// rows (already filtered) -> display entries, in row order:
//   { kind: "group", key, level, type, rows, qty } at the first member's place,
//   then its rows as { kind: "row", row, child: true } when the group is open;
//   { kind: "row", row } for everything else.
export function groupRows(rows, open = new Set()) {
  const groups = new Map();
  (rows || []).forEach((r) => {
    if (!GROUPED_TYPES.has(r.type)) return;
    const key = `${r.type}|${r.level == null ? "" : r.level}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(r);
  });
  const out = [];
  const placed = new Set();
  (rows || []).forEach((r) => {
    if (!GROUPED_TYPES.has(r.type)) { out.push({ kind: "row", row: r }); return; }
    const key = `${r.type}|${r.level == null ? "" : r.level}`;
    const members = groups.get(key);
    if (members.length < 2) { out.push({ kind: "row", row: r }); return; }
    if (placed.has(key)) return;
    placed.add(key);
    out.push({ kind: "group", key, level: r.level, type: r.type, rows: members, qty: members.reduce((n, m) => n + (m.qty || 1), 0) });
    if (open.has(key)) members.forEach((m) => out.push({ kind: "row", row: m, child: true }));
  });
  return out;
}
